import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as AcceleratorStatusActions from './accelerator-status.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root',
})
export class AcceleratorStatusListener {
  constructor(
    private store: Store,
    private signalRService: SignalRService,
  ) { }

  initStore() {
    this.store.dispatch(new AcceleratorStatusActions.AcceleratorStatusRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.ACCELERATORSTATUS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Get:
          this.store.dispatch(new AcceleratorStatusActions.AcceleratorStatusRefresh());
          break;
      }
    });
  }
}
